import { RowSelectionOptions } from '@ag-grid-community/core'
import { Button, Dropdown } from 'antd'
import { useMemo, useState } from 'react'
import { MoreCircleIcon } from 'src/assets/icons'
import '../styles/index.scss'
import { RowOption } from '../table.model'
import { useTableContext } from './TableProvider'

export interface TableActionColumnProps<T> {
  data: T & RowOption
}

function TableActionColumn<T>(props: TableActionColumnProps<T>): JSX.Element {
  const { data } = props
  const { displayActionColumn, actionDropdownItems, tableRef } = useTableContext()
  const [isDropdownVisible, setIsDropdownVisible] = useState(false)

  const items = useMemo(() => actionDropdownItems?.(data) ?? [], [actionDropdownItems, data])

  if (!displayActionColumn) {
    return <></>
  }

  const isRowSelectionMultiple = () => {
    const rowSelection = tableRef.current?.api?.getGridOption('rowSelection')
    return rowSelection === 'multiple' || (rowSelection as RowSelectionOptions)?.mode === 'multiRow'
  }

  const handleDropdownVisibilityChange = (visible: boolean) => {
    setIsDropdownVisible(visible)
  }

  return (
    <>
      {!isRowSelectionMultiple() && (
        <Dropdown
          trigger={['click']}
          menu={{ items }}
          onVisibleChange={handleDropdownVisibilityChange}
          disabled={data.isActionDisabled || items.length === 0}
        >
          <Button
            className={`button-more-action ${isDropdownVisible ? 'active-button-more-action' : ''}`}
            icon={<MoreCircleIcon />}
            disabled={data.isActionDisabled || items.length === 0}
          />
        </Dropdown>
      )}
    </>
  )
}

export default TableActionColumn
